interface Word {
  word: string;
  start: number;
  end: number;
  punctuated_word?: string;
}

function formatSRTTime(seconds: number): string {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.floor(seconds % 60);
  const ms = Math.round((seconds % 1) * 1000);
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')},${String(ms).padStart(3, '0')}`;
}

const SENTENCE_END = /[.!?…]$/;
const CLAUSE_BREAK = /[,;:–—]$/;
const MAX_WORDS = 12;
const MIN_WORDS = 3;

export function generateSRT(words: Word[]): string {
  if (!words || words.length === 0) return '';

  const lines: string[] = [];
  let index = 1;
  let chunk: Word[] = [];

  const flush = () => {
    if (chunk.length === 0) return;
    const start = chunk[0].start;
    const end = chunk[chunk.length - 1].end;
    const text = chunk.map(w => w.punctuated_word || w.word).join(' ');

    lines.push(`${index}`);
    lines.push(`${formatSRTTime(start)} --> ${formatSRTTime(end)}`);
    lines.push(text);
    lines.push('');
    index++;
    chunk = [];
  };

  for (const word of words) {
    chunk.push(word);
    const display = word.punctuated_word || word.word;

    if (SENTENCE_END.test(display)) {
      flush();
    } else if (CLAUSE_BREAK.test(display) && chunk.length >= MIN_WORDS) {
      flush();
    } else if (chunk.length >= MAX_WORDS) {
      flush();
    }
  }

  flush();

  return lines.join('\n');
}
